import { Box } from '@chakra-ui/layout';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Text } from '@revelio/ui';

import { StepperIndicator } from './StepperIndicator';
import styles from './stepper.module.css';

type Step = {
  id: string;
  title: string;
  details?: ReactNode;
  isActive?: boolean;
  isComplete?: boolean;
};

type StepperProps = {
  steps: Step[];
};

export const Stepper = ({ steps }: StepperProps) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => {
        return (
          <div className={styles.stepperItem} key={step.id}>
            <div
              className={classNames(styles.indicatorContainer, {
                [styles.indicatorContainerWithLine ?? '']:
                  index !== steps.length - 1,
              })}
            >
              <StepperIndicator
                isActive={step.isActive ?? false}
                isComplete={step.isComplete ?? false}
              />
            </div>
            <Box pt={1}>
              <Text weight="semibold" className={styles.stepperItemTitle}>
                {step.title}
              </Text>
              <div className={styles.stepperItemDetails}>{step.details}</div>
            </Box>
          </div>
        );
      })}
    </div>
  );
};
